module.exports = __webpack_public_path__ + "static/media/contact.0432274a.png";